import { createSlice } from '@reduxjs/toolkit';
import LocalStorageService from '../common/local-storage-service';
import { APIStatus } from '../../common/enums/api-status';
import { getCurrentUserFromJwt } from '../../helpers/jwt-helper';
import { loginAsync, refreshTokenAsync, verifyTokenAsync } from './authThunk';
const initialState = {
    status: APIStatus.IDLE,
    currentUser: getCurrentUserFromJwt()
};
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout(state) {
            state.currentUser = undefined;
            LocalStorageService.removeMSAccessToken();
            LocalStorageService.removeAccessToken();
            LocalStorageService.removeRefreshToken();
            state.apiError = undefined;
            state.status = APIStatus.IDLE;
            state.currentUserDetail = undefined;
        },
        resetAuthApiState(state) {
            state.status = APIStatus.IDLE;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(loginAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.currentUser = getCurrentUserFromJwt(action.payload.accessToken);
            LocalStorageService.setAccessToken(action.payload.accessToken);
            LocalStorageService.setRefreshToken(action.payload.refreshToken);
        })
            .addCase(loginAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(refreshTokenAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(refreshTokenAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.currentUser = getCurrentUserFromJwt(action.payload.accessToken);
            LocalStorageService.setAccessToken(action.payload.accessToken);
            LocalStorageService.setRefreshToken(action.payload.refreshToken);
        })
            .addCase(refreshTokenAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
        });
        builder
            .addCase(verifyTokenAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(verifyTokenAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(verifyTokenAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { logout, resetAuthApiState } = authSlice.actions;
export default authSlice.reducer;
